import Sortable from './sortable'

export default {
  ...Sortable,
}
